export const PUBLIC_PRICING = {
  free: { monthly: 0, annual: 0, monthlyLabel: '$0', annualLabel: '$0', note: 'Free forever' },
  creator: { monthly: 19, annual: 190, monthlyLabel: '$19', annualLabel: '$190', note: 'Save $38 / year' },
  pro: { monthly: 49, annual: 490, monthlyLabel: '$49', annualLabel: '$490', note: 'Save $98 / year' },
} as const;

export type PublicPlanId = keyof typeof PUBLIC_PRICING;
